export default {
  getBaigolfHost(state) {
    return state.baigolfHost
  },
  getUserData (state) {
    if(state.userData.user_name){
      state.userData.user_name = String(state.userData.user_name).slice(0, 8) + '***';
    }
    return state.userData;
  },
  getUserWallet (state) {
    return state.userWallet;
  },
  getAreaCode (state) {
    return state.areaCode;
  },
  getRouteName (state) {
    return state.routerName;
  },

  getRooms(state){
    let result = +state.rooms;
    const local = window.localStorage.getItem('rooms');

    if(local){
      result = +local;
    }

    return result;
  },

  getAdults(state){
    let result = +state.adults;
    const local = window.localStorage.getItem('adults');

    if(local){
      result = +local;
    }

    return result;
  },

  getChildren(state, getters, rootState){
    let result = +state.children;
    const local = window.localStorage.getItem('children');

    if(local){
      result = +local;
    }

    return result;
  },

  getAges(state, getters, rootState){
    let result = state.ages;
    const local = window.localStorage.getItem('ages');

    if(local){
      result = local;
    }

    return result;
  },
}



// WEBPACK FOOTER //
// ./src/store/getter.js